import { __extends } from "tslib";
import * as React from 'react';
import { namespacedClassnames } from '../../common/namespace-classes';
import { ReactTelephoneInput } from '@wix/cloned-react-telephone-input';
import { guessUserCountry } from '@wix/answers-lib';
export var phoneInputKey = 'phone-input';
export var CountryCode;
(function (CountryCode) {
    CountryCode["il"] = "il";
    CountryCode["us"] = "us";
    CountryCode["gb"] = "gb";
    CountryCode["ru"] = "ru";
    CountryCode["br"] = "br";
    CountryCode["fr"] = "fr";
    CountryCode["ca"] = "ca";
    CountryCode["au"] = "au";
    CountryCode["de"] = "de";
    CountryCode["it"] = "it";
    CountryCode["es"] = "es";
    CountryCode["pt"] = "pt";
    CountryCode["jp"] = "jp";
    CountryCode["kr"] = "kr";
    CountryCode["cn"] = "cn";
})(CountryCode || (CountryCode = {}));
var PhoneInput = /** @class */ (function (_super) {
    __extends(PhoneInput, _super);
    function PhoneInput() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // tslint:disable-next-line:max-line-length
        _this.flagsImagePath = 'https://d2x3xhvgiqkx42.cloudfront.net/12345678-1234-1234-1234-1234567890ab/2017/02/19/7fe0a748-752c-4a0a-9c0b-45aa87afce89.png';
        _this.preferredCountries = Object.values(CountryCode);
        _this.state = {
            isFocused: false
        };
        _this.inputElem = null;
        _this.stringToUserPhoneNumber = function (phoneNumber) {
            var regex = /\+|\-|\(|\)| /g;
            var phoneNumberArray = phoneNumber.split(regex);
            if (phoneNumberArray.length === 2) {
                // regex doesnt work here (no phone nunmber template for country)
                var phoneNumberNoTemplate = phoneNumberArray[1];
                return {
                    countryCode: phoneNumberNoTemplate[0] || '',
                    number: phoneNumberNoTemplate.slice(1)
                };
            }
            return {
                countryCode: phoneNumberArray[1],
                number: phoneNumberArray.slice(2).join('').replace(regex, '')
            };
        };
        _this.onInputPhoneNumberChange = function (num) {
            var n = _this.stringToUserPhoneNumber(num);
            _this.props.onChange(n);
        };
        _this.onFocus = function () {
            _this.setState({ isFocused: true });
            if (_this.props.onFocus) {
                _this.props.onFocus();
            }
        };
        _this.onBlur = function () {
            _this.setState({ isFocused: false });
            if (_this.props.onBlur) {
                _this.props.onBlur();
            }
        };
        return _this;
    }
    PhoneInput.prototype.componentDidMount = function () {
        if (this.inputElem) {
            var v = this.inputElem.value;
            this.inputElem.value = '';
            this.inputElem.value = v;
        }
    };
    PhoneInput.prototype.render = function () {
        var _this = this;
        var _a = this, props = _a.props, state = _a.state;
        var isFocused = state.isFocused ? 'is-focused' : '';
        var isDisabled = props.disabled ? 'is-disabled' : '';
        var classNames = namespacedClassnames(phoneInputKey, this.props.className, isFocused, isDisabled);
        var inputProps = {
            disabled: props.disabled,
            autoFocus: props.autoFocus,
            ref: function (elem) { return _this.inputElem = elem; }
        };
        var defaultCountry = (props.guessCountryCode && guessUserCountry()) || props.defaultCountry || CountryCode.us;
        return (React.createElement("div", { className: classNames },
            React.createElement(ReactTelephoneInput, { defaultCountry: defaultCountry, flagsImagePath: this.flagsImagePath, preferredCountries: this.preferredCountries, value: "" + props.value.countryCode + props.value.number, onChange: this.onInputPhoneNumberChange, onFocus: this.onFocus, onBlur: this.onBlur, inputProps: inputProps, placeholder: props.placeholder })));
    };
    return PhoneInput;
}(React.PureComponent));
export { PhoneInput };
//# sourceMappingURL=index.js.map